/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles';

// Composables
import { createVuetify } from 'vuetify';

import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import '@mdi/font/css/materialdesignicons.css';

import { VTreeview } from 'vuetify/labs/VTreeview';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    components: {
        VTreeview,
        ...components,
    },
    aliases: {
        VAlertInfo: components.VAlert,
    },
    defaults: {
        VAlertInfo: {
            density: 'compact',
            border: 'start',
            color: '#f4f4f4',
            'border-color': '#000000',
        },
    },
    directives,
    theme: {
        defaultTheme: 'myCustomTheme',
        themes: {
            myCustomTheme: {
                colors: {
                    primary: '#000',

                    error: '#E13B59',
                    warning: '#9c4c06',
                    gray: '#444444',
                    lightGray: '#e8e8e8',
                    darkGray: '#2A2F3A',
                    black: '#121212',
                    white: '#fbfafd',
                    success: '#577B3B',
                    highlight: '#4D67D5',

                    background: '#eeedf0',
                },
                variables: {
                    'theme-background': '#eeedf0',
                    'theme-surface': '#f9f9f9',
                },
                /*  primary: '#5ABAB2',
                secondary: '#F5B63F',
                accent: '#EE6F2D',
                error: '#CB474B',
                info: '#F5B63F',
                success: '#5ABAB2',
                warning: '#c2610c',

                backdrop: '#2A2F3A', */
            },
        },
    },
});
